import React from 'react';

const Gameboy = ({
  showIntro,
  inPage,
  pages,
  selectedIndex,
  pageContent,
  projectList,
  viewingProjectDetails,
  selectedProjectIndex,
  detailContentRef,
  projectItemRefs,
  handleUp,
  handleDown,
  handleA,
  handleB,
  handleLeft,
  handleRight,
  urlFor,
  setReaderView,
}) => {
  return (
    <div className="portfolio-container">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <button
          className="toggle-button"
          onClick={() => setReaderView(true)}
        >
          Switch to Reader View
        </button>
        <div className="gameboy">
          <div className="screen">
            {showIntro ? (
              <div className="boot-sequence">
                <h2 className="boot-logo">Nintendo®</h2>
                <p className="boot-text">GAME BOY</p>
                <p className="boot-blink">©1990 Thomas Dielesen</p>
              </div>
            ) : !inPage ? (
              <>
                <div className="screen-content">
                  <h2>Menu</h2>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    {pages.map((page, index) => (
                      <li
                        key={page}
                        className={index === selectedIndex ? "selected" : ""}
                      >
                        {index === selectedIndex ? "> " : ""}
                        {page}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="screen-instructions">
                  Use ▲▼ to select, A to enter.
                </div>
              </>
            ) : (
              <>
                {pages[selectedIndex] === "Projects" ? (
                  viewingProjectDetails ? (
                    <>
                      <h2>{projectList[selectedProjectIndex]?.title}</h2>
                      <div
                        ref={detailContentRef}
                        className="screen-content scrollable"
                      >
                        <p>{projectList[selectedProjectIndex]?.description || "No description available."}</p>
                        {projectList[selectedProjectIndex]?.image && (
                          <img
                            src={urlFor(projectList[selectedProjectIndex].image).width(400).url()}
                            alt={projectList[selectedProjectIndex].title}
                            style={{ maxWidth: "100%", margin: "0.5rem 0" }}
                          />
                        )}
                        {projectList[selectedProjectIndex]?.video && (
                          <p>
                            <a
                              href={projectList[selectedProjectIndex].video}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Watch Video
                            </a>
                          </p>
                        )}
                        {projectList[selectedProjectIndex]?.url && (
                          <p>
                            <a
                              href={projectList[selectedProjectIndex].url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View Project
                            </a>
                          </p>
                        )}
                        <p style={{ marginTop: "0.5rem", fontSize: "0.75rem" }}>
                          <strong>How I did it:</strong>
                          <br />
                          {projectList[selectedProjectIndex]?.howIDidIt || "No details provided."}
                        </p>
                      </div>
                      <div className="screen-instructions">
                        Use ▲▼ to scroll, B to go back.
                      </div>
                    </>
                  ) : (
                    <>
                      <h2 style={{ margin: "0.25rem 0" }}>Projects</h2>
                      <div className="screen-content scrollable">
                        {projectList.length === 0 ? (
                          <p>Loading projects...</p>
                        ) : (
                          <ul style={{ listStyle: "none", padding: 0, textAlign: "left", margin: 0 }}>
                            {projectList.map((project, index) => (
                              <li
                                key={project._id}
                                ref={(el) => (projectItemRefs.current[index] = el)}
                                className={index === selectedProjectIndex ? "selected" : ""}
                              >
                                {index === selectedProjectIndex ? "> " : ""}
                                {project.title}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      <div className="screen-instructions">
                        Use ▲▼ to select, A to view. Press B to go back.
                      </div>
                    </>
                  )
                ) : (
                  <>
                    <div className="screen-content">
                      {pageContent[pages[selectedIndex]]}
                    </div>
                    <div className="screen-instructions">
                      Press B to go back.
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <div className="buttons">
            <div className="dpad">
              <button className="up" onClick={handleUp}>▲</button>
              <button className="left" onClick={handleLeft}>◀</button>
              <button className="center"></button>
              <button className="right" onClick={handleRight}>▶</button>
              <button className="down" onClick={handleDown}>▼</button>
            </div>
            <div className="ab-buttons">
              <button className="a" onClick={handleA}>A</button>
              <button className="b" onClick={handleB}>B</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gameboy;